import {productService} from '@/assets/js/http'

/**
 * 活动详情
 * @param {int} id 
 */
export function noticeDetailAPI(id) {
    return productService({
        url:`api/notifyinfo/announcements/${id}`,
        method: 'get'
    })
}